<template>
  <div class="modal fade modal-last-load" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Set Last Load
        </div>
        <div class="modal-body">

          <p class="modal-text" v-if="haveLoadsToCancel">
            To confirm what your last load will be please select the load number and reference so we can start to finalise your job.
          </p>
          <p class="modal-text" v-else>
            There are no loads scheduled that need to be cancelled. You may confirm the finalising of the job by clicking the button below.
          </p>

          <ul class="list-last-load" v-if="haveLoadsToCancel">
            <li v-for="load in scheduledLoadsWithLastInProgress">
              <div class="radio">
                <input type="radio" name="radio-last-load" :id="`load-${load.id}`" :value="load.id" v-model="last">
                <label :for="`load-${load.id}`">
                  {{ load.reference_number }}

                  <small class="truncate">
                    <template v-if="load.isScheduled">Scheduled:</template>
                    <template v-else>In Progress:</template>
                    {{ load.loading_date }} &ndash; Rego {{ load.registration }}
                  </small>
                </label>
              </div>
            </li>
          </ul>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Cancel</button>
          <ladda-button
            :on-click="handleSaveLastLoad"
            button-type="submit"
            size="small"
            type="success">
            Save &amp; Finalise
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { LaddaButton } from 'components/forms'
  import { orderBy, findLast, filter, dropWhile, map } from 'lodash'
  import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
  import { ADD_LOAD } from 'vx/mutations'
  import moment from 'moment'
  import $ from 'jquery'

  export default {
    components: {
      LaddaButton
    },

    data () {
      return {
        last: null
      }
    },

    computed: {
      ...mapState('job', ['job']),
      ...mapGetters('load', ['loadsDecorated']),

      /**
       * Determine if we have loads to cancel.
       *
       * @return boolean
       */
      haveLoadsToCancel () {
        return this.scheduledLoadsWithLastInProgress.length > 0
      },

      /**
       * Get the scheduled loads and also the last in progress load.
       *
       * @return array
       */
      scheduledLoadsWithLastInProgress () {
        const orderByStatus = load => {
          return load.isInProgress ? 1 : 0
        }

        const orderByLoadingDate = load => {
          return moment(load.loading_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }

        let loads = filter(this.loadsDecorated, load => load.isScheduled)
        let inProgress = findLast(orderBy(this.loadsDecorated, [orderByLoadingDate], ['asc']), load => load.isInProgress)

        if (inProgress) {
          loads.push(inProgress)
        }

        return orderBy(loads, [orderByLoadingDate, orderByStatus, 'id'], ['asc', 'desc', 'asc'])
      }
    },

    methods: {
      ...mapActions('load', ['cancelLoad']),
      ...mapActions('job', ['finaliseJob']),
      ...mapMutations('load', [ADD_LOAD]),

      /**
       * Handle saving the last load.
       *
       * Cancels all loads after the selected last load and finalises the job.
       *
       * @return Promise
       */
      handleSaveLastLoad () {
        const notLastLoadPredicate = (load) => (load.id !== this.last)

        let loadsToCancel = filter(dropWhile(this.scheduledLoadsWithLastInProgress, notLastLoadPredicate), notLastLoadPredicate)

        const cancelLoadIteratee = (load) => {
          return this.cancelLoad(load.id).then(this.addLoadToJob)
        }

        return Promise.all(map(loadsToCancel, cancelLoadIteratee))
          .then(this.handleFinalisingJob)
          .then(this.closeLastLoadModal)
      },

      /**
       * Add the load to the jobs loads in the state. This will replace
       * the load with the updated details.
       *
       * @param object
       */
      addLoadToJob (response) {
        this[ADD_LOAD](response.data)

        return response
      },

      /**
       * Finalise the job. Will update the jobs status and commit it to the state.
       *
       * @return Promise
       */
      handleFinalisingJob () {
        return this.finaliseJob(this.job.id)
      },

      /**
       * Close the modal.
       *
       * @return void
       */
      closeLastLoadModal () {
        $(this.$el).modal('hide')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LastLoadModal.vue?25715496